import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { createRoomType, updateRoomType } from "services/RoomTypeService";

const RoomTypeForm = () => {
  const [formData, setFormData] = useState({
      room_type: ""    
    });
  
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  const { isEdit, editFormData } = location.state || {
      isEdit: false,
      editFormData: {},
    };


 useEffect(() => {
      if (isEdit && editFormData) { 
        setFormData(editFormData);               
      }
    }, [isEdit, editFormData]);

   const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({ ...prevData, [name]: value }));      
    };
    
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setErrors({});
      setLoading(true);
      let response;
      if (isEdit) {
        response = await updateRoomType(formData);
      } else {
        response = await createRoomType(formData);
      }

      setLoading(false);
      if (response?.data?.success) {
        navigate("/room-types");
      } else if (response?.data?.errors) {
        const serverErrors = {};
        for (const field in response.data.errors) {
          serverErrors[field] = response.data.errors[field][0];
        }
        setErrors(serverErrors);
      }
    } catch (error) {
      console.error("Error adding room type:", error);
    }
  };
  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-hotel"></i>
        </div>
        <div className="header-title">
          <h1>Room Type</h1>
          <small>Add Room Type</small>
        </div>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-sm-12">
            <div
              className="card lobicard all_btn_card"
              id="lobicard-custom-control1"
              data-sortable="true"
            >
              <div className="card-header all_card_btn">
                <div className="card-title custom_title">
                  <Link className="btn btn-add" to="/cities">
                    <i className="fa fa-list"></i> RoomTypes List{" "}
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <form className="col-sm-12" onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Hotel Name */}
                    <div className="col-lg-5 col-md-6 mb-3">
                      <div className="form-group">
                        <label>Room Type</label>
                        <input
                          type="text"
                          className="form-control"
                          name="room_type"
                          placeholder="Room Type"
                          value={formData.room_type}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>                  

                    {/* Submit */}
                    <div className="col-lg-2 col-md-6">
                      <div className="reset-button">
                        <button
                          type="submit"
                          className="btn btn-success"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RoomTypeForm;
